import React from 'react';
import SubNav from '../components/subNav';
import SEO from '../components/SEO';
import { baseUrl } from '../config';



const Connect = () => {
  return (
    <>
    <SEO
      title="Connect with Filmmakers"
      description="Connect and network with filmmakers, crew, and talent worldwide through ProducerBuddy's professional networking tools."
      url="https://producerbuddy.pilomation.com/connect"
      robots="noindex, nofollow"
    />
    <SubNav/>
    <div className='bg-gray-900 text-white min-h-screen'>
      {/* Hero Section */}
      <div className='bg-gray-800 py-16'>
        <div className='max-w-6xl mx-auto text-center'>
          <h1 className='text-4xl font-extrabold text-yellow-400'>
            Get Connected with Distributors
          </h1>
          <p className='text-gray-300 text-lg py-4 max-w-3xl mx-auto'>
            Take the next step to get your movie into the hands of distributors around the world. Whether you're looking for digital, theatrical, or broadcast distribution, we're here to help.
          </p>
          <button className='bg-yellow-400 hover:bg-yellow-500 text-gray-900 font-semibold px-6 py-3 rounded-lg shadow-lg'>
            Submit Your Film
          </button>
        </div>
      </div>

      {/* How It Works Section */}
      <div className='py-12 mt-4'>
        <div className='max-w-6xl mx-auto text-center'>
          <h2 className='text-3xl font-bold text-yellow-400 mb-6'>
            How It Works
          </h2>
          <div className='flex flex-col lg:flex-row gap-8'>
            <div className='flex-1 bg-gray-800 p-6 rounded-lg shadow-lg'>
              <h3 className='font-bold text-xl'>Step 1: Submit Your Movie</h3>
              <p className='text-gray-300 mt-3'>
                Fill in the form with all the relevant details about your movie, including genre, target audience, and budget.
              </p>
            </div>
            <div className='flex-1 bg-gray-800 p-6 rounded-lg shadow-lg'>
              <h3 className='font-bold text-xl'>Step 2: Review and Connect</h3>
              <p className='text-gray-300 mt-3'>
                Our platform matches you with potential distributors and sales agents who can bring your movie to the masses.
              </p>
            </div>
            <div className='flex-1 bg-gray-800 p-6 rounded-lg shadow-lg'>
              <h3 className='font-bold text-xl'>Step 3: Distribution Process</h3>
              <p className='text-gray-300 mt-3'>
                Distributors will help place your movie on the right platforms, whether digital, theatrical, or TV broadcast.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Submission Form Section */}
      <div className='bg-gray-800 py-16 '>
        <div className='max-w-6xl mx-auto mt-4'>
          <h2 className='text-3xl font-bold text-yellow-400 text-center mb-6'>
            Submit Your Film
          </h2>
          <form className='bg-gray-700 p-8 rounded-lg shadow-lg max-w-3xl mx-auto'>
            <div className='grid grid-cols-1 gap-6'>
              <input
                type='text'
                placeholder='Film Title'
                className='w-full px-4 py-2 rounded-lg bg-gray-900 text-white border border-gray-600 focus:outline-none'
              />
              <input
                type='text'
                placeholder='Director'
                className='w-full px-4 py-2 rounded-lg bg-gray-900 text-white border border-gray-600 focus:outline-none'
              />
              <input
                type='text'
                placeholder='Profile name'
                className='w-full px-4 py-2 rounded-lg bg-gray-900 text-white border border-gray-600 focus:outline-none'
              />
              <textarea
                placeholder='Film Description'
                className='w-full px-4 py-2 rounded-lg bg-gray-900 text-white border border-gray-600 focus:outline-none'
                rows={5}
              />
              <button className='bg-yellow-400 hover:bg-yellow-500 text-gray-900 font-semibold px-6 py-3 rounded-lg shadow-lg w-full'>
                Submit Your Film
              </button>
            </div>
          </form>
        </div>
      </div>

      {/* Why Choose Us Section */}
      <div className='py-12'>
        <div className='max-w-6xl mx-auto text-center mt-4'>
          <h2 className='text-3xl font-bold text-yellow-400 mb-6'>
            Why Choose Our Platform
          </h2>
          <p className='text-gray-300 text-lg'>
            We connect filmmakers with distributors who can maximize your film's potential. Whether you're aiming for streaming services, international cinemas, or television, our platform has the right contacts for you.
          </p>
        </div>
      </div>

      {/* Testimonials Section */}
      <div className='py-12 mt-4'>
        <div className='max-w-6xl mx-auto text-center'>
          <h2 className='text-3xl font-bold text-yellow-400 mb-6'>
            Success Stories
          </h2>
          <div className='flex flex-col lg:flex-row gap-8'>
            <div className='flex-1 bg-gray-800 p-6 rounded-lg shadow-lg'>
              <p className='text-gray-300'>
                "Thanks to this platform, my film was picked up by a top distributor and is now streaming on major platforms worldwide."
              </p>
              <h3 className='font-bold text-xl mt-3'>- Jane Doe, Filmmaker</h3>
            </div>
            <div className='flex-1 bg-gray-800 p-6 rounded-lg shadow-lg'>
              <p className='text-gray-300'>
                "I never thought I'd get a theatrical release, but with their help, my movie is in cinemas across the country."
              </p>
              <h3 className='font-bold text-xl mt-3'>- John Smith, Director</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
    </>
    
  );
};

export default Connect;

